export default __webpack_public_path__ + "static/media/stuart-marshall-bthere-2021-contributions.3fbd6a87.png";